/* eslint-disable @typescript-eslint/adjacent-overload-signatures */
import {Injectable} from '@angular/core';

import {BehaviorSubject, Observable, of, Subject} from 'rxjs';

import {DecimalPipe} from '@angular/common';
import {debounceTime, delay, switchMap, tap} from 'rxjs/operators';
import {SortColumn, SortDirection} from '../directives/NgbdSortableHeader';
import {InvestorDB} from '../data/tables/investor';

interface SearchResult {
    tableItem: any[];
    total: number;
}

interface State {
    page: number;
    pageSize: number;
    searchTerm: string;
    sortColumn: SortColumn;
    sortDirection: SortDirection;
}

const compare = (v1: string | number, v2: string | number) => v1 < v2 ? -1 : v1 > v2 ? 1 : 0;

function sort(tableItem: InvestorDB[], column: SortColumn, direction: string): InvestorDB[] {
    if (direction === '' || column === '') {
        return tableItem;
    } else {
        return [...tableItem].sort((a, b) => {
            const res = compare(a[column], b[column]);
            return direction === 'asc' ? res : -res;
        });
    }
}

// function matches(table: InvestorDB, term: string, pipe: PipeTransform) {
//     return table.type.toLowerCase().includes(term.toLowerCase())
//     // || pipe.transform(table.invoice).includes(term)

// }
@Injectable({ providedIn: 'root' })
export class TableService {
    public _ChangedData$ = new BehaviorSubject<boolean>(false);
    userData;
    private _search$ = new Subject<void>();
    private _state: State = {
        page: 1,
        pageSize: 10,
        searchTerm: '',
        sortColumn: '',
        sortDirection: ''
    };

    constructor(private pipe: DecimalPipe) {
        this.setData()
    }

    private _loading$ = new BehaviorSubject<boolean>(true);

    get loading$() { return this._loading$.asObservable(); }

    private _tableItem$ = new BehaviorSubject<any[]>([]);

    get tableItem$() { return this._tableItem$.asObservable(); }

    private _total$ = new BehaviorSubject<number>(0);

    get total$() { return this._total$.asObservable(); }

    get page() { return this._state.page; }

    set page(page: number) {
        this._set({ page });
    }

    get pageSize() { return this._state.pageSize; }

    set pageSize(pageSize: number) { this._set({ pageSize }); }

    get searchTerm() { return this._state.searchTerm; }

    set searchTerm(searchTerm: string) { this._set({ searchTerm }); }

    set sortColumn(sortColumn: SortColumn) { this._set({ sortColumn }); }

    set sortDirection(sortDirection: SortDirection) { this._set({ sortDirection }); }

    setData() {
        this._search$.pipe(
            tap(() => this._loading$.next(true)),
            debounceTime(200),
            switchMap(() => this._search()),
            delay(200),
            tap(() => this._loading$.next(false))
        ).subscribe(result => {
            console.log(result)
            this._tableItem$.next(result.tableItem);
            this._total$.next(result.total);
        });

        this._search$.next();
    }

    setUserData(val: object) {
        this.userData = val;
    }

    deleteSingleData(name: string) {
        const tableItem = this.userData;
        const total = tableItem.length;

        tableItem.map(item => {
            if (name === item.name) {
                this.userData.splice(name, 1);
            }
        })

        return (
            this._tableItem$.next(tableItem),
            this._total$.next(total)
        )

    }


    private _set(patch: Partial<State>) {
        Object.assign(this._state, patch);
        this._search$.next();
    }

    private _search(): Observable<SearchResult> {
        const { sortColumn, sortDirection, pageSize, page, searchTerm } = this._state;

        // 1. sort
        let tableItem: any = sort(this.userData, sortColumn, sortDirection);

        // 2. filter
        const total = tableItem?.length;
        // tableItem = tableItem.filter(country => matches(country, searchTerm, this.pipe));

        tableItem = tableItem
            ?.map((item, i) => ({ id: i + 1, ...item }))
            ?.slice((page - 1) * pageSize, (page - 1) * pageSize + pageSize);
        return of({ tableItem, total });
    }

}

